var Cookies = require('js-cookie');

const videos = document.querySelectorAll('.e-video');

function initVideo(video) {
	const videoPlay = video.querySelector('.e-video__thumbnail');
	const videoIframe = video.querySelector('iframe');

	/**
	 * Initialize the video behavior based on cookie consent
	 */
	function init() {
		addEventListeners();
		checkCookiesAndInitVideo();
	}

	/**
	 * Add event listeners for video play and cookie button clicks
	 */
	function addEventListeners() {
		document.addEventListener('DOMContentLoaded', checkCookiesAndInitVideo);
		videoPlay.addEventListener('click', playVideo);

		// Listen for global cookie update event
		document.addEventListener('si_cookie_notice_updated', checkCookiesAndInitVideo);
	}

	/**
	 * Check cookies and initialize video accordingly
	 * Replaces the container content with iframe if cookies are accepted
	 */
	function checkCookiesAndInitVideo(e) {
		if (e) e.preventDefault();

		setTimeout(() => {
			if (cookiesAccepted()) {
				video.classList.remove('cookie-notice');
				video.classList.add('paused');
			} else {
				video.classList.add('cookie-notice');
			}
		}, 100);
	}

	/**
	 * Play the video by setting the iframe's source
	 */
	function playVideo(e) {
		e.preventDefault();
		video.classList.remove('paused');
		video.classList.add('playing');
		videoIframe.src = videoIframe.dataset.src;
	}

	/**
	 * Check if cookies allow video to be played
	 * @returns {boolean} - True if cookies are accepted, false otherwise
	 */
	function cookiesAccepted() {
		try {
			const basicCookie = Cookies.get('si-cookie-settings-saved-basic');
			const basicSettings = Cookies.get('si-cookie-settings-basic');
			const categoryCookie = Cookies.get('si-cookie-settings-saved-categories');
			const categorySettings = Cookies.get('si-cookie-settings-categories');

			if (basicCookie === 'true' && basicSettings === 'full') {
				return true;
			} else if (categoryCookie === 'true') {
				const acceptedCookies = JSON.parse(categorySettings);
				if (acceptedCookies.marketing && acceptedCookies.statistics) {
					return true;
				}
			}
		} catch (error) {
			console.error('Error checking cookies:', error);
		}

		return false;
	}

	init();
}

// Initialize all videos if present on the page
if (videos.length) {
	videos.forEach(function (video) {
		initVideo(video);
	});
}
